import {
    RESET_COMPANY_AUTHENTICATION_OPEN_MODAL,
    RESET_COMPANY_AUTHENTICATION_CLOSE_MODAL,
    RESET_COMPANY_AUTHENTICATION_REQUEST,
    RESET_COMPANY_AUTHENTICATION_RESULT,
} from 'Redux/actionTypes';

export const resetCompAuthenticationOpenModal = (data) => ({
    type: RESET_COMPANY_AUTHENTICATION_OPEN_MODAL,
    payload: data
})

export const resetCompAuthenticationCloseModal = () => ({
    type: RESET_COMPANY_AUTHENTICATION_CLOSE_MODAL
})

export const resetCompAuthenticationRequest = (data) => ({
    type: RESET_COMPANY_AUTHENTICATION_REQUEST,
    payload: data
})

export const resetCompAuthenticationResult = (result) => ({
    type: RESET_COMPANY_AUTHENTICATION_RESULT,
    payload: result
})